import {parseAuthError} from '../utils/parseAuthError';

export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  if (typeof payload !== 'string') {
    console.error(payload);
    newState.lastError = null;
    newState.lastErrorDescription = 'Unknown error';
    return newState;
  }
  const {error, errorDescription} = parseAuthError(payload);
  newState.lastError = error;
  newState.lastErrorDescription =
    errorDescription ?? 'An error occurred. Please try again or contact support.';
  return newState;
};
